import { $user_config } from "@/configs/user";
import { $cookie } from "@/cookie";
import { ProvideCreate } from "@/di/provide_create";
import { UserService } from "@/services/user";
import { type UserState, COOKIE_KEYS, UserStateManager } from "@/state/user";
import { Subscribe } from "@/utils/subscribe";

interface Model {
  mobile: string;
  email: string;
  name: string;
}

@ProvideCreate({
  sxhr: UserService,
})
class User {
  sxhr!: UserService;

  private static instance: User | null = null;
  // 事件系统
  private $userSubject = new Subscribe<{
    end: UserState;
    change: UserState;
  }>();

  public $end = this.$userSubject.replay("end");
  public $change = this.$userSubject.on("change");

  private stateManager: UserStateManager;

  private constructor() {
    this.stateManager = new UserStateManager();

    // 订阅状态变化
    this.stateManager.subscribe((state) => {
      this.syncToConfig(state);
      this.$userSubject.emit("change", state);
    });

    // 初始化配置
    this.initializeConfig();
  }

  static create(): User {
    if (!User.instance) {
      User.instance = new User();
    }
    return User.instance;
  }

  private initializeConfig(): void {
    const cookieId = this.stateManager.getState("cookieId");
    if (!cookieId) {
      $user_config.set("cookieId", cookieId);
    }
  }

  private syncToConfig(state: UserState): void {
    $user_config.updateConfig({
      cookieId: state.cookieId,
      sess: state.sess,
    });
  }

  // 获取当前状态快照
  get snapshot(): Readonly<UserState> {
    return this.stateManager.snapshot;
  }

  // 状态更新方法
  setState(
    update: Partial<UserState> | ((prev: UserState) => Partial<UserState>),
    options?: { emitEvent?: boolean; deepCompare?: boolean },
  ): void {
    this.stateManager.setState(update, options);
  }

  // 订阅状态变化
  subscribe(listener: (state: UserState) => void): () => void {
    return this.stateManager.subscribe(listener);
  }

  async init(): Promise<void> {
    const cookieId = this.stateManager.getState("cookieId");
    if (!cookieId) {
      void this.sxhr.getUserId().then((res) => {
        $cookie.set(COOKIE_KEYS.ANONYMOUS_ID, res.anonymous_id, {
          expires: 30,
          path: "/",
        });
        this.setState({
          cookieId: res.anonymous_id,
        });
        this.update(true);
      });
      return;
    }
    this.setState({ cookieId });
    this.update(true);
  }

  update(b = false): void {
    const model: Model = {
      mobile: "",
      email: "",
      name: "",
    };
    this.setState({
      mobile: model.mobile,
      email: model.email,
      name: model.name,
    });
    if (b) {
      this.setEnd();
    }
  }

  setEnd(): void {
    this.$userSubject.emit("end", this.snapshot);
  }
}

export const $user = User.create();
export { User };
